<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FKEf5h/tc-custom/9780253063786.jpg?1733030817634" alt="This image is the cover for the book We Are All Survivors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">We Are All Survivors
      </h1>
      <p class="bookDescription body article font2">
        <p><b>What is the role of folklore in the discussion of catastrophe and trauma? How do disaster survivors use language, ritual, and the material world to articulate their experiences? What insights and tools can the field of folkloristics offer survivors for navigating and narrating disaster and its aftermath? Can folklorists contribute to broader understandings of empathy and the roles of listening in ethnographic work?</b></p><p><i>We Are All Survivors</i> is a collection of essays exploring the role of folklore in the wake of disaster. Contributors include scholars from the United States and Japan who have long worked with disaster-stricken communities or are disaster survivors themselves; individual chapters address Hurricane Katrina, Hurricane Maria, and two earthquakes in Japan, including the earthquake, tsunami, and nuclear disaster of 2011. Adapted from a 2017 special issue of <i>Fabula</i> (from the International Society for Folk Narrative Research), the book includes a revised introduction, an additional chapter with original illustrations, and a new conclusion considering how folklorists are documenting the COVID-19 pandemic.</p><p><i>We Are All Survivors</i> bears witness to survivors' expressions of remembrance, grieving, and healing.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carl Lindahl, Michael Dylan Foster, Kate Parker Horigan
      </h2>
      
      <p class="authorDescription body article"><P><P>Carl Lindahl is Martha Gano Houstoun Research Professor in English at the University of Houston, cofounder of the disaster response project Surviving Katrina and Rita in Houston, and founder of the earthquake response project Memwa Ayisyen / Haitian Memory. He is author (with B. J. Ancelet and M. Gaudet) of <I>Second Line Rescue: Improvised Responses to Katrina and Rita</I>.</P><P>Michael Dylan Foster is Professor in the Department of East Asian Languages and Cultures at the University of California, Davis. He is author of <I>The Book of Yokai: Mysterious Creatures of Japanese Folklore</I> and co-editor (with Lisa Gilman) of <I>UNESCO on the Ground: Local Perspectives on Intangible Cultural Heritage</I>.</P><P>Kate Parker Horigan is Associate Professor in the Department of Folk Studies and Anthropology at Western Kentucky University. She is author of <I>Consuming Katrina: Public Disaster and Personal Narrative</I>.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ec9a64e